import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { ActivityCard } from "../activity-card";
import { styles } from "./style";
import { RootState } from "redux/store";
import { getLeadActivitiesChronological, getLeadsByAgentId, getLeadsByUnassignedAgent, getUser } from "redux/selector";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { FeatherIcon } from "component/shared/feather-icon";
import { ChevronDown, Layers } from "react-feather";
import { Lead } from "model/lead";
import { Pagination } from "../pagination";
import { LoadingIndicator } from "component/shared/loading-indicator";
import * as env from "shared/env";
import { AppCard } from "component/shared/app-card";
import { hasSearchAgent } from "shared/search-agent-permission";
import {
	ALL_ACTIVITY_FILTER_ID,
	filterLeadActivities,
	getLeadActivityFilterOptions,
} from "shared/lead-activity-display";

const mapStateToProps = (state: RootState, ownProps: any) => {
  const agentId = state.agents.value;
  const unassigned = agentId === -1
  return {
	agentId,
	leadsByAgent: getLeadsByAgentId(state, agentId),
	leadsByUnassigned: getLeadsByUnassignedAgent(state),
	unassigned,
	leadActivities: getLeadActivitiesChronological(state),
	loading: state.leadActivities.loading,
	showSearchAgent: hasSearchAgent(getUser(state)),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({}, dispatch);

interface Props extends 
	ReturnType<typeof mapStateToProps>, 
	ReturnType<typeof mapDispatchToProps>, 
	WithStyles<typeof styles> {
	lead?: Lead,
	isAgentPage? : boolean,
}

interface State {
  selectedTypeId: number;
}

class Component extends React.Component<Props, State> {
  constructor(props: Props) {
	super(props);
	this.state = {
	  selectedTypeId: ALL_ACTIVITY_FILTER_ID
	};
  }

  handleChange(typeId: number) {
	this.setState({
	  selectedTypeId: typeId
	});
  }

  public render() {
	const { loading, leadActivities, unassigned, leadsByUnassigned, leadsByAgent, agentId, lead, classes = {}, isAgentPage, showSearchAgent } = this.props;
	const { selectedTypeId } = this.state;
	let filteredActivities;

	if (lead) {
	  // If a lead is passed in as a prop, filter activities for that specific lead.
	  filteredActivities = leadActivities.filter(activity => activity.leadId === lead.id);
	} else if (unassigned) {
	  // Filter activities for unassigned leads.
	  filteredActivities = leadActivities.filter(activity => leadsByUnassigned.some(lead => lead.id === activity.leadId));
	} else {
	  // Filter activities for leads assigned to the current agent or show all activities if agentId is not available.
	  filteredActivities = agentId ? leadActivities.filter(activity => leadsByAgent.some(lead => lead.id === activity.leadId)).slice(0, 100) : leadActivities;
	}
  
	const filteredLeadActivities = filterLeadActivities(filteredActivities, selectedTypeId);
  
	const filterOptions = getLeadActivityFilterOptions(filteredActivities, showSearchAgent);
  
  
	return (
	  <Mui.Grid container direction="column" spacing={2}>
		<Mui.Grid item>
		  <Mui.Grid container direction="row" spacing={3} wrap="nowrap" {...{ justifyContent: (lead ? "flex-end" as const : "space-between" as const), alignItems: "center" as const }}>
			{!lead && (
				<Mui.Grid item>
					<Mui.Typography variant="h3">Latest Activity</Mui.Typography>
				</Mui.Grid>
			)}
			<Mui.Grid item style={{display: filteredLeadActivities.length === 0 ? "none" : "block"}}>
			  <Mui.FormControl>
				<Mui.Select
				  value={selectedTypeId}
				  onChange={(e) => this.handleChange(Number(e.target.value))}
				  {...{
					classes: { select: classes.selectText, icon: classes.selectIcon },
					input: <Mui.Input disableUnderline />,
					IconComponent: ChevronDown,
					MenuProps: {
					  anchorOrigin: { vertical: "bottom" as const, horizontal: "left" as const },
					  transformOrigin: { vertical: "top" as const, horizontal: "left" as const },
					},
					renderValue: (value: unknown) => {
					  if (Number(value) === ALL_ACTIVITY_FILTER_ID) return "All Activity";
					  const option = filterOptions.find(o => o.id === Number(value));
					  return option ? option.label : "All Activity";
					},
				  }}
				>
					<Mui.MenuItem value={ALL_ACTIVITY_FILTER_ID}>
						<Mui.Grid container alignItems="center">
							<Mui.Grid item>
								<Mui.ListItemIcon>
									<FeatherIcon>
										<Layers />
									</FeatherIcon>
								</Mui.ListItemIcon>
							</Mui.Grid>
							<Mui.Grid item>
								All Activity
							</Mui.Grid>
						</Mui.Grid>
					</Mui.MenuItem>
				  {filterOptions.map(option => (
					<Mui.MenuItem
					  key={option.id}
					  value={option.id}
					>
						<Mui.Grid container alignItems="center">
							<Mui.Grid item>
								<Mui.ListItemIcon>
									<FeatherIcon>
										<option.icon />
									</FeatherIcon>
								</Mui.ListItemIcon>
							</Mui.Grid>
							<Mui.Grid item>
								{option.label}
							</Mui.Grid>
						</Mui.Grid>
					</Mui.MenuItem>
				  ))}
				</Mui.Select>
			  </Mui.FormControl>
			</Mui.Grid>
		  </Mui.Grid>
		</Mui.Grid>
		{!loading && !!filteredLeadActivities.length && (
		  <Mui.Grid container item xs={12} direction="column" spacing={2}>
			{lead ? (
				<Pagination>
					{filteredLeadActivities.map((activity, index) => (
						<Mui.Grid key={index} item xs={12}>
							<ActivityCard activity={activity} isAgentPage={isAgentPage} />
						</Mui.Grid>
					))}
				</Pagination>
			):
				<>
					{filteredLeadActivities.map((activity, index) => (
						<Mui.Grid key={index} item xs={12}>
							<ActivityCard activity={activity} isAgentPage={isAgentPage} showLeadName />
						</Mui.Grid>
					))}	
				</>
			}
			{selectedTypeId !== ALL_ACTIVITY_FILTER_ID && (
				<Mui.Grid item className={classes.bottomTab}>
					<Mui.Link onClick={() => this.setState({ selectedTypeId: ALL_ACTIVITY_FILTER_ID })}>
						View All Activities
					</Mui.Link>
				</Mui.Grid>
			)}
		  </Mui.Grid>
		)}
		<Mui.Grid item>
			{!!loading &&
				<AppCard><Mui.CardContent>
						<Mui.Grid container justifyContent="center">
							<Mui.Grid item>
								<LoadingIndicator />
							</Mui.Grid>
						</Mui.Grid>
				</Mui.CardContent></AppCard>
			}
		</Mui.Grid>
		{!loading && filteredLeadActivities.length === 0 &&
			<Mui.Grid container item xs={12}>
						<Mui.Grid container justifyContent="center">
							<Mui.Grid item>
								<Mui.Typography align="center">Lead activity has not yet been recorded on your site.</Mui.Typography>
							</Mui.Grid>
						</Mui.Grid>
			</Mui.Grid>
		}
	  </Mui.Grid>
	);
  }
  
}

export const LeadActivityFilter = 
	withStyles(connect(
		mapStateToProps,
		mapDispatchToProps,
	)(Component), styles)
;
